"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulerCheckoutTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const invoice_1 = require("../invoice");
const hauler_preferences_transport_1 = require("./hauler-preferences-transport");
const hauler_transport_1 = require("./hauler-transport");
exports.HaulerCheckoutTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Pick(hauler_transport_1.HaulerTransport, ['checkoutLogo', 'checkoutLogoURL', 'checkoutTermsOfService']),
    typebox_1.Type.Required(typebox_1.Type.Pick(hauler_transport_1.HaulerTransport, [
        'id',
        'name',
        'dumpsterSizes',
        'materials',
        'defaultRentPeriod',
        'rentExtensionFee',
        'maxRentalPeriod',
        'timeZone',
    ])),
    typebox_1.Type.Object({
        country: typebox_1.Type.String(),
        enforceAvailability: typebox_1.Type.Boolean(),
        checkoutAvailability: typebox_1.Type.Optional(typebox_1.Type.Object({
            disabledDaysOfWeek: typebox_1.Type.Object({
                sunday: typebox_1.Type.Boolean(),
                monday: typebox_1.Type.Boolean(),
                tuesday: typebox_1.Type.Boolean(),
                wednesday: typebox_1.Type.Boolean(),
                thursday: typebox_1.Type.Boolean(),
                friday: typebox_1.Type.Boolean(),
                saturday: typebox_1.Type.Boolean(),
            }),
            disabledDates: typebox_1.Type.Array(typebox_1.Type.String({ format: 'date' })),
            earliestDeliveryDate: typebox_1.Type.String({ format: 'date-time' }),
            deliveryCutOff: typebox_1.Type.Object({
                advanceDays: typebox_1.Type.Number(),
                cutoffTime: typebox_1.Type.String(),
            }),
            checkoutOutOfServiceAddressMessage: typebox_1.Type.Optional(typebox_1.Type.String()),
        }, { additionalProperties: false })),
        /**
         * Hauler-authored heading and sub-heading for the online checkout form. Omitted when
         * the hauler has not set one, which means "use the default".
         */
        checkoutPageTitle: typebox_1.Type.Optional(typebox_1.Type.String()),
        checkoutPageSubtitle: typebox_1.Type.Optional(typebox_1.Type.String()),
        whiteLabelSettings: typebox_1.Type.Optional(hauler_preferences_transport_1.WhiteLabelSettingsValue),
        googleAnalyticsMeasurementId: typebox_1.Type.Optional(typebox_1.Type.String()),
        featureFlagWaysteOperationsRollOff: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
        rainforestEnabled: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
        /**
         * The processor whose merchant should be used to charge this hauler. Derived
         * server-side from `paymentProcessorAccounts` (see `getActivePaymentProcessorAccountByProcessor`).
         * Returned by both the authenticated `/hauler/checkout` route and the public
         * `/hauler/checkout/:token` route — safe to surface publicly because it identifies
         * the processor only (no merchant IDs or credentials). Consumers (wayste-checkout,
         * wayste-dashboard) read this directly instead of inferring from
         * `featureFlagWaysteOperationsRollOff` / `rainforestEnabled`.
         */
        activePaymentProcessor: typebox_1.Type.Optional(invoice_1.SupportedPaymentProcessorTransport),
    }),
]);
//# sourceMappingURL=hauler-checkout-transport.js.map